import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  checked: {
    color: `${theme.palette.primary.main} !important`,
  },
  radioLabel: {
    color: theme.palette.primary.main,
  },
}))

export default styles
